import { useQuery } from '@tanstack/react-query';
import { fetchSessionHardwareFamily } from './api';
import { HardwareFamily, familyFromGraphql } from './hardwareFamily';

export const SESSION_HARDWARE_FAMILY_KEY = 'chatSessionHardwareFamily';

/**
 * The family of the session's anchor rental (kayak, bike, ...), read once
 * for the session on screen so the tag picker can narrow its options.
 * `undefined` while ant has not answered; `null` for a general session, a
 * family this console does not know, or an ant that refused: the picker
 * then shows every tag, which is the safe side of the filter.
 */
export function useSessionHardwareFamily(
  sessionId: string | null | undefined
): HardwareFamily | null | undefined {
  const query = useQuery({
    queryKey: [SESSION_HARDWARE_FAMILY_KEY, sessionId],
    queryFn: () => fetchSessionHardwareFamily(sessionId as string),
    enabled: Boolean(sessionId),
    staleTime: Infinity,
    retry: false,
  });
  if (!sessionId) return null;
  if (query.isError) return null;
  if (query.data === undefined) return undefined;
  return familyFromGraphql(query.data);
}
